module.exports = __webpack_public_path__ + "ff1b101f71796902f3015ac14e665c72.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/headscarf.png
// module id = 2305
// module chunks = 0